import React from "react";
import Distinctions from "./Distinctions"
const contact = contact => {
  return (
    <div className="Formater__contact">
      <p>Aeby Perneger & Associés SA</p>
      <p>
        Rue de Veyrier 19
        <br /> 1227 Carouge, Suisse
      </p>
      <p>
        Chemin Renou 2,
        <br /> 1005 Lausanne, Suisse
      </p>
      <p>
        Téléphone{" "}
        <a
          className="no-link"
          rel="noopener noreferrer"
          href="tel:+41 22 809 66 66"
          target="_blank"
        >
          +41 22 809 66 66
        </a>
        <br />
        Fax{" "}
        <a
          className="no-link"
          rel="noopener noreferrer"
          href="tel:+41 22 809 66 67"
          target="_blank"
        >
          +41 22 809 66 67
        </a>
      </p>
      {contact.map((ctc, index) => (
        <div key={index}>
          <a href={ctc.target} target="_blank" rel="noopener noreferrer">
            {ctc.title}
          </a>
          <br />
        </div>
      ))}
    </div>
  );
};

const profile = profile => {
  return (
    <div className="Formater__profile">
      <div dangerouslySetInnerHTML={{ __html: profile.about }} />
      <div>
        {profile.CVs.map((cv, index) => (
          <div key={'cv'+index}>
            <h2 className="name">{cv.name}</h2>
            {cv.dates.map((date, index) => (
              <div key={'cvdate'+index}>
                <div>{date.date.join("–")}</div>
                <div>{date.content}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const team = teams => {
  return (
    <div className="Formater__team">
      <h2>Associés</h2>
      <p>
        {teams.associates.map((member, index) => {
          const Tag = member.email ? "a" : "div";
          const attrs = member.email ? { href: `mailto:${member.email}` } : {};
          return (
            <Tag className="member" {...attrs} key={index}>
              {member.name + " " + member.entity}
            </Tag>
          );
        })}
      </p>
      <h2>Partenaires</h2>
      <p>
        {teams.partenaires.map((member, index) => {
          const Tag = member.email ? "a" : "div";
          const attrs = member.email
            ? { href: `mailto:${member.email}`, target: "_blank" }
            : {};
          return (
            <Tag className="member" {...attrs} key={index}>
              {member.name + " " + member.entity}
            </Tag>
          );
        })}
      </p>
      <h2>Collaboratrices et collaborateurs</h2>
      <p>
        {teams.collaborators.map((member, index) => {
          const Tag = member.email ? "a" : "div";
          const attrs = member.email ? { href: `mailto:${member.email}` } : {};
          return (
            <Tag className="member" {...attrs} key={index}>
              {member.name + " " + member.entity}
            </Tag>
          );
        })}
      </p>
      <h2>Anciennes collaboratrices et collaborateurs</h2>
      <p>{teams.old_collaborators.join(", ")}</p>
    </div>
  );
};

const jobs = (content) => {
  return <div dangerouslySetInnerHTML={{__html: content}}/>
}

const publications = (publications, history) => {
  return (
    <div className="Formater__publications">
      {publications.distinctions.length>0 &&
        <Distinctions distinctions={publications.distinctions} history={history} />
      }
      {publications.ouvrages.length>0 && <p>Ouvrages sur Aeby Perneger & Associés</p> }
      {publications.ouvrages.map((ouvrage, index) => (
        <p key={index} dangerouslySetInnerHTML={{ __html: ouvrage }} />
      ))}
      {publications.articles.length>0 && <p>Articles sur Aeby Perneger & Associés</p>}
      {publications.articles.map((article, index) => (
        <p key={index}>
          {`${article.name}, in ${article.reference}, ${article.date}`}
        </p>
      ))}
    </div>
  );
};

const socialMedia = socials => {
  return (
    <div className="Formater__socials">
      {socials.map((social, index) => (
        <a key={index} href={social.target || "/"}>
          {social.title}
        </a>
      ))}
    </div>
  );
};

export default (category, data, history=false) => {
  switch (category) {
    case "Contact":
      return contact(data.Contact);
    case "Profil":
      return profile(data.Profile);
    case "Equipe":
      return team(data.Team);
    case "Jobs":
      return jobs(data.Jobs);
    case "Publications":
      return publications(data.Publications, history);
    case "Social media":
      return socialMedia(data.Social_media);
    default:
      return <div />;
  }
};
